import React from "react";
import { connectHits } from "react-instantsearch-dom";
import { BasicDoc, Hit, HitsProvided } from "react-instantsearch-core";

import HitsCarousel from "./hits-carousel";
import HitsGrid from "./hits-grid";
import HitsRows from "./hits-rows";
import InfiniteRows from "./infinite-hits-rows";

const SearchHits: React.FunctionComponent<any> = (props): JSX.Element => {
  const { hits, mode = "grid" }: { hits: Hit<BasicDoc>[]; mode?: "grid" | "carousel" | "rows" | "infinite-rows" } = props;
  if (mode === "carousel") {
    return <HitsCarousel hits={hits} />;
  } else if (mode === "rows") {
    return <HitsRows hits={hits} />;
  } else if (mode === "infinite-rows") {
    return <InfiniteRows hits={hits} />;
  } else {
    return <HitsGrid hits={hits} />;
  }
};

export default connectHits(SearchHits);
